export class OrderDeliveryResponseModel {
    address: string;
    comment: string;
    createdAt: string;
    creator = new Creator();
    deliveryStatus: string;
    id: string;
    modifier = new Creator();
    orderId: string;
    proofOfDelivery: string;
    receivedAt: Date;
    receivedBy: string;
    scheduledDate: any;
    scheduledTime: string;
    updatedAt: string;
    userId: string;
}
export class Creator {
    id: string;
    type: string;
}

// export class OrderDeliveryResponseModel {
//     id: string;
//     deliveryStatus: string;
//     orderId: string;
//     scheduledDate: number;
//     scheduledTime: string;
//     address: string;
//     userId: string;
//     comment: string;
//     createdAt: number;
//     updatedAt: number;
//     creator: Creator;
//     modifier: Creator;
// }

// export class Creator {
//     id: string;
//     type: string;
// }


// WEBPACK FOOTER //
// ./src/app/_models/order/OrderDeliveryResponseModel.ts